import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Events } from "./pages/Events";
import { Gallery } from "./pages/Gallery";
import { Contact } from "./pages/Contact";
import { PageError } from "./pages/PageError";
import { ThemeProvider } from "@mui/material";
import { customTheme } from "./utils/Themes";
import { Articles } from "./pages/Articles";
import { Header } from "./components/Global/Header";
import { Footer } from "./components/Global/Footer";
import { WhatsAppFloat } from "./components/Global/WhatsAppFloat";
import { ViewEvent } from "./pages/subpages/ViewEvent";
import { ViewArticle } from "./pages/subpages/ViewArticle";
import { useEffect } from "react";
import { YearlyProgram } from "./pages/subpages/YearlyProgram";
import { CCChistory } from "./pages/subpages/CCChistory";
import { ParishHistory } from "./pages/subpages/ParishHistory";
import { BibleJustification } from "./pages/subpages/BibleJustification";
import { RulesTenets } from "./pages/subpages/RulesTenets";
import { Tracts } from "./pages/Tracts";
import { Join } from "./pages/Join";
import { Birthdays } from "./pages/Birthdays";
// Harvest 2026 pages — switched off after the event. Uncomment to restore.
// import { Harvest2026 } from "./pages/Harvest2026";
// import { HarvestQuizPage } from "./pages/HarvestQuizPage";

function App() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="App selection:bg-custom selection:text-white">
      <ThemeProvider theme={customTheme}>
        <Router>
          <Header />
          <ToastContainer />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/view/:slug" element={<ViewEvent />} />
            <Route path="/events/yearly" element={<YearlyProgram />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/view/:slug" element={<ViewArticle />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/ccc" element={<CCChistory />} />
            <Route path="/parish" element={<ParishHistory />} />
            <Route path="/justification" element={<BibleJustification />} />
            <Route path="/tenets" element={<RulesTenets />} />
            <Route path="/tracts" element={<Tracts />} />
            <Route path="/join" element={<Join />} />
            <Route path="/birthdays" element={<Birthdays />} />
            {/* <Route path="/harvest-2026-attendee" element={<Harvest2026 />} /> */}
            {/* <Route path="/harvest-2026-quiz" element={<HarvestQuizPage />} /> */}

            <Route path="*" element={<PageError />} />
          </Routes>
          <Footer />
          <WhatsAppFloat />
          {/* <ToastContainer position="bottom-right" autoClose={4000} /> */}
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
